import { render, staticRenderFns } from "./bastConfirmation.vue?vue&type=template&id=efb1a0a6&scoped=true&"
import script from "./bastConfirmation.vue?vue&type=script&lang=js&"
export * from "./bastConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./bastConfirmation.vue?vue&type=style&index=0&id=efb1a0a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb1a0a6",
  null
  
)

export default component.exports